import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';

import type { PermissionDto, RoleCreateInput, RoleDto, RoleUpdateInput } from './types';

export const listRoles = async (): Promise<RoleDto[]> => {
  const res = await apiClient.get<ApiSuccess<RoleDto[]>>('/roles');
  return res.data.data ?? [];
};

export const listPermissions = async (): Promise<PermissionDto[]> => {
  const res = await apiClient.get<ApiSuccess<PermissionDto[]>>('/roles/permissions');
  return res.data.data ?? [];
};

export const createRole = async (body: RoleCreateInput): Promise<RoleDto> => {
  const payload = {
    ...body,
    description: body.description?.trim() || undefined,
    permissions: body.permissions ?? [],
  };
  const res = await apiClient.post<ApiSuccess<RoleDto>>('/roles', payload);
  return res.data.data;
};

export const updateRole = async (roleCode: string, body: RoleUpdateInput): Promise<RoleDto> => {
  const res = await apiClient.patch<ApiSuccess<RoleDto>>(
    `/roles/${encodeURIComponent(roleCode)}`,
    body,
  );
  return res.data.data;
};
